import React, { Component, Fragment } from "react";
import { Col, Modal, Spin, Row, Empty, Button } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import { reportService } from "./../../../redux/services";

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			dataInicial: "",
			dataFinal: "",
			data: [],
			tableData: [],

			columnsList: [],

			dataDia: "",
			empresa_nome: "",
		};
	}

	componentDidMount() {
		document.body.classList.add("page-print", "page-print-banco-de-horas");
		this.fetchGetAll();
	}

	componentWillUnmount() {
		document.body.classList.remove("page-print", "page-print-banco-de-horas");
	}

	fetchGetAll = () => {
		this.setState({
			isLoading: true,
		});

		const params = new URLSearchParams(this.props.location.search);

		const data = {};

		if (params.has("empresas")) {
			if (params.get("empresas") !== "todos") {
				data.empresas = params.get("empresas").split(",");
			}
		} else {
			Modal.error({
				title: "Ocorreu um erro!",
				content: "Empresa não encontrada!",
				maskClosable: false,
				keyboard: false,
				closable: false,
				onOk: () => {
					// window.close();
				},
			});
			return false;
		}

		if (params.has("departamentos")) {
			if (params.get("departamentos") !== "todos") {
				data.departamentos = params.get("departamentos").split(",");
			}
		}

		if (params.has("funcionarios")) {
			if (params.get("funcionarios") !== "todos") {
				data.funcionarios = params.get("funcionarios").split(",");
			}
		}

		if (params.has("data_inicial")) {
			data.data_inicial = params.get("data_inicial");

			this.setState({
				dataInicial: moment(params.get("data_inicial")).format("DD/MM/YYYY"),
			})
		} else {
			Modal.error({
				title: "Ocorreu um erro!",
				content: "Data inicial não encontrada!",
				maskClosable: false,
				keyboard: false,
				closable: false,
				onOk: () => {
					// window.close();
				},
			});
			return false;
		}

		if (params.has("data_final")) {
			data.data_final = params.get("data_final");
			this.setState({
				dataFinal: moment(params.get("data_final")).format("DD/MM/YYYY"),
			})
		} else {
			Modal.error({
				title: "Ocorreu um erro!",
				content: "Data final não encontrada!",
				maskClosable: false,
				keyboard: false,
				closable: false,
				onOk: () => {
					// window.close();
				},
			});
			return false;
		}

        if (params.has('fora_perimetro')) {
            data.fora_perimetro = params.get("fora_perimetro");
        }

		reportService
			.geolocation(data)
			.then((response) => {
				this.setState({
					isLoading: false,
					data: response.data[0],
					tableData: response.data
				}, () => {
          setTimeout(() => {
            // Print
            document.title = 'Geolocalização';

						window.print();
						// window.close();
          }, 1000);
        })
      })
			.catch((data) => {
				this.setState({
					isLoading: false,
				});
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {

		const {
			isLoading,
			data,
			dataInicial,
			dataFinal,
			tableData,
		} = this.state;

		const { user } = this.props;
		const { name: userName } = user || {};

		const style = `
			@page {
				size: A4 landscape;
				margin:0px;
			}
		`;

		return (
			<Fragment>
				{isLoading ? (
					<div
						style={{
							position: "fixed",
							top: "150px",
							left: "50%",
							transform: "translateX(-50%)",
						}}
					>
						<Spin
							spinning={isLoading}
							indicator={<i className="fad fa-spinner-third fa-spin fa-3x" />}
						/>
					</div>
				) : (
					data ? (
						<div>
							{tableData.map((value, index) => (
								<>
									<div className="hour-bank">
										<div style={{ width: '100%' }}>
											<header className="header page-break" key={index}>
												<div className="logo-container">
													<img
														src="/images/logos/logo-complete.svg"
														alt="ByPonto"
														width="200"
													/>
													<div className="logo-title" style={{ float: 'right' }}>
														<div>
															<h1>Geolocalização</h1>
														</div>
														<div>
															<div>Período:{" "}De {dataInicial} até {dataFinal}</div>															
														</div>
														<div className="user-info">
															<h4>{userName} (Logado | {moment().format('DD/MM/YYYY HH:mm')})</h4>
														</div>
													</div>
												</div>
											</header>
										</div>
									</div>

									<div style={{ width: '50%' }}>
										<table className="table-impressao">
											<tbody className="table-impressao-interna text-center">
												<tr className="row-section">
													<td className="text-left w50">
														<p className="subtitle"><strong>Empresa:</strong>{" "}{value.empresa?.nome ?? "-"}</p>
													</td>
												</tr>
												<tr className="row-section">
													<td className="text-left w50">
														<p className="subtitle">
															<strong>{value?.empresa?.cnpj ? 'CNPJ' : 'CPF'}:</strong>
															{" "}{(value?.empresa?.cnpj || value?.empresa?.cpf) ?? "-"}
														</p>
													</td>
													<td className="text-left w50">
														<p className="subtitle"><strong>IE:</strong>{" "}{value.empresa?.ie ?? "-"}</p>
													</td>
												</tr>
												<tr className="row-section">
													<td className="text-left w50">
														<p className="subtitle"><strong>Nome:</strong>{" "}{value.funcionario?.nome ?? "-"}</p>
													</td>
												</tr>
												<tr className="row-section">
													<td className="text-left w50">
														<p className="subtitle"><strong>N° Folha:</strong>{" "}{value.funcionario?.numero_folha ?? "-"}</p>
													</td>
													<td className="text-left w50">
														<p className="subtitle"><strong>Pis/Pasep:</strong>{" "}{value.funcionario?.pis_pasep ?? "-"}</p>
													</td>
												</tr>
												<tr className="row-section">
													<td className="text-left w50">
														<p className="subtitle"><strong>Ctps:</strong>{" "}{value.funcionario?.ctps ?? "-"}</p>
													</td>
													<td className="text-left w50">
														<p className="subtitle">
															<strong>Data Admissão:</strong>{" "}
															{value?.contrato?.data_admissao
																? moment(value.contrato.data_admissao).format('DD/MM/YYYY')
																: "-"}
														</p>
													</td>
												</tr>
												<tr className="row-section">
													<td className="text-left w50">
														<p className="subtitle"><strong>Função:</strong>{" "}{value.contrato?.funcoes?.nome ?? "-"}</p>
													</td>
													<td className="text-left w50">
														<p className="subtitle"><strong>Departamento:</strong>{" "}{value.departamento?.nome ?? "-"}</p>
													</td>
												</tr>
											</tbody>
											<tfoot>
												<tr>
													<td>
														<div className="footer-space">&nbsp;</div>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>

									<div>
										<table className="table-impressao-interna table-impressao-interna-color text-left">
											<tbody>
												<tr className="table-list-header">
													<td width="120">Data</td>
													<td width="80">Hora</td>
													<td width="150">Latitude</td>
													<td width="150">Longitude</td>
													<td width="auto">Logradouro</td>
                                                    <td width="150">Batida fora do perímetro</td>
												</tr>
                                                {
                                                    value.registros.map(item => (
                                                        <tr>
                                                            <td>{moment(item.data).format('DD/MM/YYYY - ddd')}</td>
                                                            <td>{moment(item.data).format('HH:mm')}</td>
                                                            <td>{item.latitude}</td>
                                                            <td>{item.longitude}</td>
                                                            <td>{item.logradouro}</td>
                                                            <td align="center">{item.fora_perimetro ? 'Sim' : (value.funcionario?.perimetro_id ? 'Não' : 'Perímetro não cadastrado')}</td>
                                                        </tr>
                                                    ))
                                                }
											</tbody>
										</table>
									</div>
								</>
							))}
						</div>
					) : (
						<Empty description="Nenhum registro encontrado com esses parâmetros." style={{ padding: "20px", position: "absolute", top: "20px", left: "50%", transform: "translateX(-50%)" }}>
							<Button type="primary" onClick={() => window.close()}>Voltar</Button>
						</Empty>
					)
				)}
				<style dangerouslySetInnerHTML={{ __html: style }} />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.auth.userData,
	};
};

export default connect(mapStateToProps)(Index);
